//src/services/authService.js
import api from './apiService'; // Axios instance for API requests

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!localStorage.getItem('token'); // Returns true if token exists
};


// Login user
export const login = async (credentials) => {
  try {
    const response = await api.post('/users/login', credentials);
    if (response.data.success) {
      // Save token to localStorage
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Login failed' };
  }
};

// Register user
export const register = async (userData) => {
  try {
    const response = await api.post('/users/register', userData);
    return response.data; // Assuming the API returns { success, message }
  } catch (error) {
    throw error.response?.data || { message: 'Registration failed' };
  }
};

// Logout user
export const logout = () => {
  try {
    localStorage.removeItem('token'); // Remove the token
    return true; // Indicate successful logout
  } catch (error) {
    console.error('Logout failed:', error);
    return false; // Handle potential errors
  }
};

// Get current user details (optional)
export const getCurrentUser = async () => {
  try {
    const response = await api.get('/users/current-user', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`, // Attach token
      },
    });
    return response.data; // Return user details
  } catch (error) {
    throw error.response?.data || { message: 'Failed to fetch user details' };
  }
};
